import { stepcountsServices } from '../services';
import { stepcountsConstants } from '../constants'
import { loader, alert as customAlert } from 'helpers';
import { change } from 'redux-form';
import i18n from 'i18n';
import lodash from 'lodash';

const defaultFailedText = 'api_messages.SOMETHING_WENT_WRONG';

export const stepCountsAction = {
    getListsProduct,
    getStepCountLists,
    addStepCounts,
    updateStepCounts,
    deleteStepCounts,
    getStepCountById,
    getRegionList,
    getAllShopList,
    importProduct
};

function getListsProduct(params) {
    return dispatch => {
        dispatch({ type: stepcountsConstants.STEPCOUNTS_FORM_PRODUCT_LIST_LOADER, showLoader: true })
        stepcountsServices.getListsProduct(params)
            .then(
                response => {
                    try {
                        if (response.status) {
                            dispatch(success(response.data.products));
                        } else {
                            dispatch(success([]));
                        }
                    } catch (e) {
                        dispatch(success([]));
                    }
                },
                error => {
                    dispatch(success([]));
                }
            ).then(() => {
                dispatch({ type: stepcountsConstants.STEPCOUNTS_FORM_PRODUCT_LIST_LOADER, showLoader: false })
            })
    };

    function success(tmp) { return { type: stepcountsConstants.GET_PRODUCT_LIST_SUCCESS, productList: tmp } }
}

function getStepCountLists(params) {
    return dispatch => {
        // loader(dispatch, true)
        dispatch({ type: stepcountsConstants.SHOW_TABLE_LOADER })
        stepcountsServices.getStepCountLists(params)
            .then(
                response => {
                    try {
                        if (response.status) {
                            dispatch(success(response.data));
                        } else {
                            if(!response.unAlert) customAlert(dispatch, 'error', i18n.t(`api_messages.${response.message.toString()}`))
                        }
                    } catch (e) {
                        customAlert(dispatch, 'error', i18n.t(defaultFailedText))
                    }
                },
                error => {
                    customAlert(dispatch, 'error', i18n.t(defaultFailedText))
                }
            ).then(() => {
                // loader(dispatch, false)
                dispatch({ type: stepcountsConstants.HIDE_TABLE_LOADER })
            })
    }
    function success(tmp) { return { type: stepcountsConstants.GET_STEP_COUNTS_DATA_SUCCESS, data: tmp } }
}

function addStepCounts(params) {
    return dispatch => {
        loader(dispatch, true)
        stepcountsServices.addStepCounts(params)
            .then(
                response => {
                    try {
                        if (response.status) {
                            dispatch({ type: stepcountsConstants.ADD_STEP_COUNTS_SUCCESS });
                            customAlert(dispatch, 'success', i18n.t('warning_messages.step_count_was_created'));
                        } else {
                            if(!response.unAlert) customAlert(dispatch, 'error', i18n.t(`api_messages.${response.message.toString()}`))
                        }
                    } catch (e) {
                        customAlert(dispatch, 'error', i18n.t(defaultFailedText))
                    }
                },
                error => {
                    customAlert(dispatch, 'error', i18n.t(defaultFailedText))
                }
            ).then(() => {
                loader(dispatch, false)
            })
    }
}

function updateStepCounts(params) {
    return dispatch => {
        loader(dispatch, true)
        stepcountsServices.updateStepCounts(params)
            .then(
                response => {
                    try {
                        if (response.status) {
                            dispatch({ type: stepcountsConstants.EDIT_STEP_COUNTS_SUCCESS });
                            customAlert(dispatch, 'success', i18n.t('warning_messages.step_count_was_updated'));
                        } else {
                            if(!response.unAlert) customAlert(dispatch, 'error', i18n.t(`api_messages.${response.message.toString()}`))
                        }
                    } catch (e) {
                        customAlert(dispatch, 'error', i18n.t(defaultFailedText))
                    }
                },
                error => {
                    customAlert(dispatch, 'error', i18n.t(defaultFailedText))
                }
            ).then(() => {
                loader(dispatch, false)
            })
    }
}

function deleteStepCounts(params) {
    return dispatch => {
        loader(dispatch, true)
        stepcountsServices.deleteStepCounts(params)
            .then(
                tmp => {
                    if (tmp.status) {
                        dispatch({ type: stepcountsConstants.DELETE_STEP_COUNTS_SUCCESS });
                        customAlert(dispatch, 'success', i18n.t('warning_messages.step_count_was_deleted'));
                    } else {
                        if(!tmp.unAlert) customAlert(dispatch, 'error', tmp.message.toString())
                    }
                },
                error => {
                    customAlert(dispatch, 'error', i18n.t(defaultFailedText))
                }
            ).then(() => {
                loader(dispatch, false)
            })
    };
}

function getStepCountById(id) {
    return dispatch => {
        loader(dispatch, true)
        stepcountsServices.getStepCountById(id)
            .then(
                response => {
                    if (response.status) {
                        let selectedProductList = [];
                        const stepCountData = response.data
                        let formInitialValues = stepCountData
                        let allShopListSelected = []
                        let regionSelected = []

                        // add product list
                        let productAmount = {};
                        let productPriority = {};
                        
                        lodash.forEach(stepCountData.products, function (value) {
                            let productId = value.productId;
                            selectedProductList.push({
                                _id: value.productId,
                                skuId: value.productSku,
                                name: value.product.name,
                                prefix: value.product.prefix
                            });
                
                            productAmount = {
                                ...productAmount,
                                [productId]: value.amount
                            }

                            productPriority = {
                                ...productPriority,
                                [productId]: value.priority
                            }
                        })
                        formInitialValues.productAmount = productAmount;
                        formInitialValues.productPriority = productPriority;
                        console.log('formInitialValues', formInitialValues)
                   
                        dispatch({ type: stepcountsConstants.OPEN_EDIT_STEP_COUNTS, 
                            data: formInitialValues, 
                            selectedProductList: selectedProductList,
                            regionSelected,
                            allShopListSelected,
                            productListMaster : lodash.get(stepCountData, 'product'),
                            rewardImagePreview: stepCountData.rewardDetail.imgPath
                        })
                        dispatch(change('FORM_STEPCOUNTS', 'selectedProductCount', lodash.size(selectedProductList)))
                        
                    } else {
                        customAlert(dispatch, 'error', i18n.t(`api_messages.${response.message.toString()}`))
                    }
                },
                error => {
                    customAlert(dispatch, 'error', i18n.t(defaultFailedText))
                }
            ).then(() => {
                loader(dispatch, false)
            })
    };
}


function getRegionList() {
    return (dispatch) => {
        stepcountsServices.getRegionLists().then(
        (response) => {
          if (response.status) {
            dispatch(success(response.data.shopRegions))
          } else {
            if (!response.unAlert)
              customAlert(
                dispatch,
                "error",
                i18n.t(`api_messages.${response.message.toString()}`)
              )
          }
        },
        (error) => {
          customAlert(dispatch, "error", i18n.t(defaultFailedText))
        }
      )
    }
  
    function success(data) {
      return { type: stepcountsConstants.STEP_COUNT_GET_REGION_LIST, data }
    }
  }


function getAllShopList(params, shopListSelected) {
    return (dispatch) => {
        stepcountsServices.getShopListsByRegion(params).then(
        (response) => {
          if (response.status) {
              const isArrayFormat = Array.isArray(response.data)
              let formatData = []
              if(isArrayFormat){
                 formatData = lodash.map(response.data,((data,index)=>{
                    return data.shopLists
                  }))
                  formatData = lodash.flatten(formatData)
              }else{
                formatData=[...lodash.get(response.data, "shopLists")] 
              }
              //remove shopList Has Selected
              let shopListRemovedSelected = lodash.filter(formatData,(data,index)=>{
                  return !lodash.find(shopListSelected,{_id:data._id})
              })
              shopListRemovedSelected = shopListRemovedSelected.map(data=>{
                  return {
                      ...data,
                      shopRegionId:data.shopRegionId?data.shopRegionId:'not_specified'
                  }
              })
              
            const formData = {
                shopListSelected,
                shopList:shopListRemovedSelected
            }
            dispatch(success(formData))
          }
        },
        (error) => {
          customAlert(dispatch, "error", i18n.t(defaultFailedText))
        }
      )
    }
   
  
    function success(data) {
      return { type: stepcountsConstants.STEP_COUNT_GET_SHOP_LIST, data }
    }
  }

function importProduct(params) {
    return dispatch => {
       loader(dispatch, true)
       stepcountsServices.importProduct(params)
          .then(
             response => {
                if (response.status) {
                   dispatch({
                      type: stepcountsConstants.SHOW_STEP_COUNT_IMPORT_PRODUCT_RESULT,
                      data: response.data
                   });
                } else {
                   if(!response.unAlert) customAlert(dispatch, 'error', i18n.t(`${response.message.toString()}`))
                }
             },
             error => {
                customAlert(dispatch, 'error', i18n.t(defaultFailedText))
             }
          ).then(() => {
             loader(dispatch, false)
          })
    }
 }